module.exports = __webpack_public_path__ + "static/assets/18e415f18cb06e8e8c7bbf9eca833016.png";